module.exports = __webpack_public_path__ + "static/media/noun-vehicle-839688-142350-cropped.798c2a03.svg";